module.exports = __webpack_public_path__ + "img/icon-check-blue.9312ee60.svg";